/** 集团驾驶舱静态资源（wu-cloud OSS） */
export const OSS_BASE = 'https://wu-cloud.oss-cn-shanghai.aliyuncs.com/web-file'

export const groupScreenOss = {
  /** 面板 / 顶栏装饰 */
  titleStripMain: `${OSS_BASE}/title-strip-main.png`,
  titleStripSub: `${OSS_BASE}/title-strip-sub.png`,
  panelTitleFrame: `${OSS_BASE}/panel-title-frame.png`,
  panelTitleIcon: `${OSS_BASE}/panel-title-icon.png`,
  headerFrame: `${OSS_BASE}/header-frame.png`,
  backdrop: `${OSS_BASE}/backdrop.png`,
  /** KPI 图标 */
  bjt: `${OSS_BASE}/bjt.png`,
  cs: `${OSS_BASE}/cs.png`,
  bj: `${OSS_BASE}/bj.png`,
  tc: `${OSS_BASE}/tc.png`,
  zxl: `${OSS_BASE}/zxl.png`,
  sd: `${OSS_BASE}/sd.png`,
  mj: `${OSS_BASE}/mj.png`,
  gd: `${OSS_BASE}/gd.png`,
  dp: `${OSS_BASE}/dp.png`,
  sj: `${OSS_BASE}/sj.png`
}

export default groupScreenOss
